import React from 'react'

const BannerLanding = (props) => {

    let background = props.background;

    return (
        <section id="banner" className="style" style={{ backgroundImage: `url(${background})` }}>

        </section>
    );
}


export default BannerLanding



// WEBPACK FOOTER //
// ./src/components/BannerLanding.js